// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TibGO","imageField":"styles_imageField__KPqYl","detailsCollapse":"styles_detailsCollapse__EXUG3"};